import React from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import arrow1 from "../images/arrow1.png";
import { Image } from "react-bootstrap";
const bounceVariants = {
  hidden: { y: 0, opacity: 0 },
  visible: { 
    y: [0, -10, 0], 
    opacity: 1, 
    transition: { duration: 0.6, ease: "easeInOut", repeat: 2 } 
  }
};

const bounceTitleVariants = {
  hidden: { x: 0, opacity: 0 }, 
  visible: { 
    x: [0, 5, -5, 0],
    opacity: 1, 
    transition: { duration: 0.6, ease: "easeInOut", repeat: 1 }
  }
};


const ServicesSection = () => {
  return (
    <div id="services" className="container-fluid bg py-5">
      <div className="container">
      <motion.div
        className="mb-4 custom-title  mx-auto"
        initial={{ scale: 1.2 }} 
        whileInView={{ scale: 1 }} 
        transition={{ duration: 0.8, ease: "easeOut" }} 
        viewport={{ once: false, amount: 0.3 }} 
      >
        Services
      </motion.div>
        {[
          {
            title: "Website Development",
            description:
              "Whether you want a new website or to revamp an existing one, our web design services will elevate your online marketing — from branding to website performance and ranking!",
          },
          {
            title: "Monthly IT Support Plan",
            description:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi sodales dolor leo, luctus cursus metus consequat quis.",
          },
          {
            title: "Ongoing Support and Training",
            description:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi sodales dolor leo, luctus cursus metus consequat quis.",
          },
        ].map((service, index) => (
          <div key={index} className="qw py-4">
            <div className="row ">
              <div className="col-md-4">
              <motion.h4
                className="title"
                variants={bounceTitleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }} 
              >
                {service.title}
              </motion.h4>
            </div>
              <div className="col-md-5">
                <p className="descr mb-0">{service.description}</p>
              </div>
              <div className="col-md-3 d-flex justify-content-md-end align-items-center mt-3 mt-md-0">
                  <motion.a
                    href="#"
                    className="btn btn-outline-dark rounded-pill px-4 py-2 fw-semibold"
                    animate={{ opacity: [1, 0.5, 1] }}
                    transition={{ duration: 1, repeat: Infinity }}
                  >
                    MORE
                    <motion.div
                      animate={{ scale: [1, 1.2, 1] }} 
                      transition={{ duration: 0.6, repeat: Infinity, ease: "easeInOut" }}
                      style={{ display: "inline-block", marginLeft: "8px" }}
                    >
                      <Image className="arrow-image" src={arrow1} alt="Mockup" fluid />
                    </motion.div>
                  </motion.a>
                </div>

            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesSection;


